import React, { createContext, useContext, useRef } from 'react';
import {EventWebSocket, useWebSocketClient} from "./UseWebSocketClient";
import {AppContext} from "../context/AppContext";

type WebSocketClientType = {
    subscribe: (cb: (payload: EventWebSocket) => void) => () => void;
};

const WebSocketContext = createContext<WebSocketClientType | null>(null);

export const WebSocketProvider = ({ children } : {
    children: React.ReactNode;
}) => {
    const context = useContext(AppContext);
    const session = context.session;
    const client = useWebSocketClient(session);

    return (
        <WebSocketContext.Provider value={client}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = (): WebSocketClientType => {
    const context = useContext(WebSocketContext);
    if (!context) {
        throw new Error('useWebSocket must be used inside a WebSocketProvider');
    }
    return context;
};
